import React from "react"
import Img from "gatsby-image"
import { useStaticQuery, graphql } from "gatsby"
import { Link } from "react-scroll"

// Styles
import "./Header.scss"

// Img
import buchenSie from "../../images/Storer_top_Eis_Charlie-f4435efba29157a75d04c8bc92e709f2.svg"

const Header = () => {
  const headerImg = useStaticQuery(graphql`
    query {
      fingerTip: file(relativePath: { eq: "finger_tip.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }

      writing: file(relativePath: { eq: "writing.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }

      sending: file(relativePath: { eq: "sending.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }

      titleImg: file(relativePath: { eq: "Eis_Charlie_home_short-2.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)
  return (
    <header id="home" className="header-container my-container">
      <div className="main-img-wrapper">
        <Img
          fluid={headerImg.titleImg.childImageSharp.fluid}
          fadeIn={false}
          loading="eager"
        />
      </div>
      <div className="explanation-container">
        <div className="explanation-wrapper">
          <Img
            fluid={headerImg.fingerTip.childImageSharp.fluid}
            fadeIn={false}
            loading="eager"
          />
          <p>Attraktionen finden</p>
        </div>
        {/* Line */}
        <div className="line"></div>
        <div className="explanation-wrapper">
          <Img
            fluid={headerImg.writing.childImageSharp.fluid}
            fadeIn={false}
            loading="eager"
          />
          <p>Unverbindlich anfragen</p>
        </div>
        {/* Line */}
        <div className="line"></div>
        <div className="explanation-wrapper">
          <Img
            fluid={headerImg.sending.childImageSharp.fluid}
            fadeIn={false}
            loading="eager"
          />
          <p>Wir melden uns bei Ihnen</p>
        </div>
      </div>
      <Link
        to="fahrgeschaefte"
        spy={true}
        smooth={true}
        duration={500}
        activeClass="active"
      >
        <div className="buchen-sie">
          <img src={buchenSie} alt="buchen sie bei uns" />
        </div>
      </Link>
    </header>
  )
}

export default Header
